import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var CreateFlashcardsFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.75 38.262H16.945l-7.903 1.265a4.555 4.555 0 0 1-5.217-3.777L.405 14.388a4.555 4.555 0 0 1 3.778-5.217l6.362-1.018c.548-1.9 2.3-3.29 4.377-3.29h14.574c2.06 0 3.8 1.367 4.363 3.243l6.653 1.065a4.554 4.554 0 0 1 3.777 5.217L40.87 35.75a4.555 4.555 0 0 1-5.217 3.777l-7.903-1.265Zm6.3-28.28v23.725c0 1.386-.618 2.628-1.595 3.463l3.486.558a2.733 2.733 0 0 0 3.13-2.266l3.42-21.362a2.733 2.733 0 0 0-2.267-3.13l-6.173-.988ZM8.755 37.728l3.253-.52a4.545 4.545 0 0 1-1.64-3.5V10.025l-5.896.944a2.733 2.733 0 0 0-2.267 3.13l3.42 21.362a2.733 2.733 0 0 0 3.13 2.266Zm8.597-16.47a.91.91 0 0 0 0 1.822h3.947v3.948a.91.91 0 1 0 1.822 0V23.08h3.947a.91.91 0 1 0 0-1.821H23.12V17.31a.91.91 0 0 0-1.822 0v3.948h-3.947Z"
  }));
});
CreateFlashcardsFill.displayName = 'CreateFlashcardsFill';
CreateFlashcardsFill.defaultProps = {
  'aria-label': 'CreateFlashcardsFill'
};
export default CreateFlashcardsFill;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/CreateFlashcardsFill.js
// module id = 3136
// module chunks = 11